import { ArrowRight } from "lucide-react";

import type { Dispute } from "@/types/dispute";

import { cn } from "@/lib/utils";
import useAuthStore from "@/store/auth";
import { Link } from "@tanstack/react-router";

interface DisputeCardProps {
	dispute: Dispute;
	className?: string;
}

export default function DisputeCard({ dispute, className }: DisputeCardProps) {
	const user = useAuthStore(state => state.user);

	return (
		<Link to={`/${user?.userType === "BUYER" ? "buyer" : "vendor"}/dispute/$disputeid`} params={{ disputeid: dispute.order.id }} state={{ dispute }}>
			<div className={cn("border rounded-lg p-4 ", className)}>
				<div className="flex gap-4">
					<div className="w-32 h-32 relative rounded-lg overflow-hidden">
						<img src={dispute.order.contract.contractItem.length ? dispute.order.contract.contractItem[0].productId?.photos[0] : "/placeholder.svg"} alt={dispute.order.contract.title} className="object-cover" />
					</div>

					<div className="flex-1">
						<div className="flex flex-wrap justify-between items-start gap-2">
							<div>
								<h3 className="font-medium capitalize">{dispute.order.contract.title}</h3>
							</div>
							<span className={cn("px-3 py-1  bg-green-50 text-green-600 border border-green-600 text-sm rounded-md capitalize", {
								"bg-red-50 text-red-600 border border-red-600": dispute.disputeStatus !== "RESOLVED"
							})}
							>
								{dispute.disputeStatus.replace("_", " ").toLowerCase()}
							</span>
						</div>

						<div className="mt-4">
							<p className="font-medium">
								Contract Code:
								{dispute.order.contract.contractCode}
							</p>
							<p className="text-gray-600 text-xs">
								Buyer name
								's order (Disputed item:
								{dispute.finalDecisionReason}
								)
							</p>
						</div>

						<button className="mt-4 text-primary font-medium flex items-center gap-2 hover:gap-3 transition-all">
							View dispute information
							<ArrowRight size={16} />
						</button>
					</div>
				</div>
			</div>
		</Link>
	);
}
